export default __webpack_public_path__ + "static/train-30e39773ad1b2ea1991d971760b735ea.png";